import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=da5a7b10&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=da5a7b10&prod&lang=css"
import style1 from "./Review.vue?vue&type=style&index=1&id=da5a7b10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a7b10",
  null
  
)

export default component.exports